import { config } from "../config"; 
import React, { useState, useEffect, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutlet } from 'react-router-dom';

import Header from "./layout-components/header/Header";
import Sidebar from "./layout-components/sidebar/Sidebar";
import Footer from "./layout-components/footer/Footer";
// import Settings from "../modules/settings/views/Settings";

import NotificationManager from "../NotificationManager";

// import AclRoute from "../routes/AclRoute";
// import AclRoutes from "../routes/AclRouter";

import { getMenuRoutes } from "../routes/Router";
// import { conversationApi, resetConversation } from "../modules/conversation/reducers/conversationSlice"


export default (props) => {
  const dispatch = useDispatch();
  const [width, setWidth] = useState(window.innerWidth);
  
  const settings = useSelector((state) => state.settingReducer);
  const location = useLocation();

  const outlet = useOutlet()

  // useEffect(() => {
  //   if(location.pathname !== '/conversations') {
  //     dispatch(resetConversation())
  //   }
  // }, [location, dispatch]);
  
  // useEffect(() => {
  //   dispatch( conversationApi.initConversationProxy() );
  // }, [dispatch]);

  useEffect(() => {
    const updateDimensions = () => {
      let element = document.getElementById("main-wrapper");
      if(element) {
        setWidth(window.innerWidth);
        switch (settings.activeSidebarType) {
          case "full":
          case "iconbar":
            if (width < 1170) {
              element.setAttribute("data-sidebartype", "mini-sidebar");
              element.classList.add("mini-sidebar");
            } else {
              element.setAttribute(
                "data-sidebartype",
                settings.activeSidebarType
              );
              element.classList.remove("mini-sidebar");
            }
            break;
  
          case "overlay":
            if (width < 767) {
              element.setAttribute("data-sidebartype", "mini-sidebar");
            } else {
              element.setAttribute(
                "data-sidebartype",
                settings.activeSidebarType
              );
            }
            break;
  
          default:
        }
      }
    };

    if (document.readyState === "complete") {
      updateDimensions();
    }
    window.addEventListener("load", updateDimensions.bind(null));
    window.addEventListener("resize", updateDimensions.bind(null));
    return () => {
      window.removeEventListener("load", updateDimensions.bind(null));
      window.removeEventListener("resize", updateDimensions.bind(null));
    };
  }, [settings.activeSidebarType, width]);

  return (
    <>
      <NotificationManager />
      <div id={config.instance.id} className={config.instance.id} >
        <div
          id="main-wrapper"
          dir={settings.activeDir}
          data-theme={settings.activeTheme}
          data-layout={settings.activeThemeLayout}
          data-sidebartype={settings.activeSidebarType}
          data-sidebar-position={settings.activeSidebarPos}
          data-header-position={settings.activeHeaderPos}
          data-boxed-layout={settings.activeLayout}
        >
          {/*--------------------------------------------------------------------------------*/}
          {/* Header                                                                         */}
          {/*--------------------------------------------------------------------------------*/}
          <Header />
          
          {/*--------------------------------------------------------------------------------*/}
          {/* Sidebar                                                                        */}
          {/*--------------------------------------------------------------------------------*/}
          <Sidebar {...props} routes={getMenuRoutes()} />
          
          {/*--------------------------------------------------------------------------------*/}
          {/* Page Main-Content                                                              */}
          {/*--------------------------------------------------------------------------------*/}
          <div className="page-wrapper d-block">
            <div className="page-content container-fluid">
              {outlet || <>Select page</>}
            </div>
            <Footer />
          </div>
          {/*--------------------------------------------------------------------------------*/}
          {/* Settings from which you can set all the Layout Settings                      */}
          {/*--------------------------------------------------------------------------------*/}
          {/* <Settings /> */}
        </div>
      </div>
    </>
  );
};
